import template from './wc-count.jade';
import validation from '../../../services/validation';

export default angular.module('cian.addForm.commonWcCount', []).directive('cianAfCommonWcCount', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'deviceService',
    function (deviceService) {
      this.isMobile = deviceService.isMobile;

      this.validation = validation(this.form, 'wcsCount', {
        parse: 'Введите число',
      });
    },
  ],
  controllerAs: 'wcCount',
  template,
})).name;
